import { pxChangeVw } from "@/utils";
import ReactECharts from "echarts-for-react";

const PieChart: React.FC = (_props: any) => {
  const option = {
    tooltip: {
      trigger: "none",
    },
    legend: {
      show: false,
    },
    color: ["#BCFF7E", "rgba(255,255,255,0.3)"],
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["50%", "70%"],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: true,
            position: "center",
            color: "#4c4a4a",
            formatter: "{total|" + 32 + "}" + "\n\r" + "{active|AQI}",
            rich: {
              total: {
                fontSize: 18,
                fontWeight: 500,
                fontFamily: "微软雅黑",
                color: "#FFF",
                lineHeight: 24,
              },
              active: {
                fontFamily: "微软雅黑",
                fontSize: 12,
                color: "rgba(255, 255, 255, 0.66)",
              },
            },
          },
          emphasis: {
            show: true,
          },
        },
        lableLine: {
          normal: {
            show: false,
          },
          emphasis: {
            show: true,
          },
          tooltip: {
            show: false,
          },
        },
        emphasis: {
          disabled: false,
          scale: false,
          scaleSize: 0,
        },
        data: [
          { value: 32, name: "视频广告" },
          { value: 78, name: "联盟广告" },
        ],
      },
    ],
  };
  return <ReactECharts option={option} style={{ height: pxChangeVw("145px"), width: pxChangeVw("145px") }} />;
};

export default PieChart;
